import { createContext } from "react"
import { PerguntaPesquisaSatisfacaoInicial } from "../models/perguntaPesquisaSatisfacaoModel"
import type { PerguntaPesquisaSatisfacaoModel } from "../models/perguntaPesquisaSatisfacaoModel"
import type { PerguntaPesquisaSatisfacaoActionModel } from "./perguntaPesquisaSatisfacaoActions"

type PerguntaPesquisaSatisfacaoContextProps = {
    dados: PerguntaPesquisaSatisfacaoModel
    dispatch: React.Dispatch<PerguntaPesquisaSatisfacaoActionModel>
    salvar: () => Promise<void>
    erroCarregamento: string | null
}

const initialContextValue: PerguntaPesquisaSatisfacaoContextProps = {
    dados: PerguntaPesquisaSatisfacaoInicial,
    dispatch: () => {},
    salvar: async () => {},
    erroCarregamento: null,
}

export const PerguntaPesquisaSatisfacaoContext =
    createContext<PerguntaPesquisaSatisfacaoContextProps>(initialContextValue)
